import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.sendPostMessageToIframe();
  }

  sendPostMessageToIframe() {
    const currentOrigin = window.location.origin;
    const allowedOrigins = [
      "https://dev.goodbyegoodboy.com.au",
      "https://www.goodbyegoodboy.com.au",
      "https://dev-store.goodbyegoodboy.com.au",
      "https://store.goodbyegoodboy.com.au",
    ];

    window.addEventListener("message", (event) => {
      if (!allowedOrigins.includes(event.origin)) return;

      let messageToPost;

      if (event.data === "getHomeUrlFromApp") {
        messageToPost = { type: "url", value: currentOrigin + this.element.dataset.url };
      } else if (event.data === "getDescriptionFromApp") {
        messageToPost = { type: "description", value: this.element.dataset.description };
      } else if (event.data === "getProductTitleFromApp") {
        messageToPost = { type: "title", value: this.element.dataset.title };
      } else if (event.data === "getCompletedDescriptionFromApp") {
        messageToPost = { type: "completedDescription", value: this.element.dataset.completedDescription };
      }

      event.source.postMessage(messageToPost, event.origin);
    });
  }
}
